export function setupResizer() {
  const resizer = document.getElementById("resizer");
  const playerContainer = document.getElementById("spine-player-container");
  const bottomPanel = document.getElementById("bottom-panel");

  if (!resizer || !playerContainer || !bottomPanel) return;

  let startY: number;
  let startPlayerHeight: number;
  let startPanelHeight: number;

  const onMouseDown = (e: MouseEvent) => {
    startY = e.clientY;
    startPlayerHeight = playerContainer.getBoundingClientRect().height;
    startPanelHeight = bottomPanel.getBoundingClientRect().height;

    resizer.classList.add("active");
    document.body.style.cursor = "row-resize";
    
    const iframes = document.querySelectorAll("iframe");
    iframes.forEach(iframe => (iframe as HTMLElement).style.pointerEvents = "none");

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  const onMouseMove = (e: MouseEvent) => {
    const deltaY = e.clientY - startY;
    const newPlayerHeight = startPlayerHeight + deltaY;
    const newPanelHeight = startPanelHeight - deltaY;

    if (newPlayerHeight < 100 || newPanelHeight < 100) return;
    
    playerContainer.style.flex = `0 0 ${newPlayerHeight}px`;
    bottomPanel.style.flex = `0 0 ${newPanelHeight}px`;
  };

  const onMouseUp = () => {
    resizer.classList.remove("active");
    document.body.style.cursor = "";
    
    const iframes = document.querySelectorAll("iframe");
    iframes.forEach(iframe => (iframe as HTMLElement).style.pointerEvents = "");

    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mouseup", onMouseUp);
  };

  resizer.addEventListener("mousedown", onMouseDown);
}
